import React from "react";

import { createBasicColumn, createNumericColumn } from "./TableColumnConfig";
import withTableData from "./withTableData";

const Licenses = ({ tableData, TableWrapper, getCommonTableOptions }) => {
    const columns = [
        createBasicColumn("product", "Product", "170px"),
        createBasicColumn("license_status", "Status"),
        {
            ...createNumericColumn("license_tier_max", "Max Vol", "100px"),
            options: {
                ...createNumericColumn("license_tier_max", "Max Vol", "100px").options,
                customBodyRender: (value) => {
                    if (value && value !== "-") {
                        return value.toLocaleString("en-US");
                    }
                    return value;
                },
            },
        },
        createNumericColumn("license_usage_assets", "Usage"),
        createBasicColumn("license_account_id", "License Account"),
        createBasicColumn("license_bundle_version", "Bundle Version"),
        createBasicColumn("license_last_je_run", "Last Used"),
        createBasicColumn("license_bundle_last_updated", "Last Updated"),
        createBasicColumn("license_end_date", "License End"),
    ];

    return (
        <TableWrapper
            data={tableData}
            columns={columns}
            options={getCommonTableOptions("CARR")}
            loading="Loading licenses..."
        />
    );
};

export default withTableData(Licenses, {
    title: "Licenses",
    transformOptions: {
        dateFields: ["license_last_je_run", "license_bundle_last_updated", "license_end_date"],
    },
    sortBy: (a, b) => {
        if (a.is_primary === "Y" && b.is_primary !== "Y") return -1;
        else if (a.is_primary !== "Y" && b.is_primary === "Y") return 1;
        else return 0;
    },
});
